import React from 'react';
import ReactPlayer from 'react-player';

const YouTubeVideoComponent = ({ videoId }) => {
  const isValidUrl = typeof videoId === 'string' && (videoId.startsWith('http://') || videoId.startsWith('https://'));

  return (
    <div className=' w-full h-full flex items-center justify-center'>
      {isValidUrl ? (
        <ReactPlayer url={videoId} controls={true} width="100%" height="100%" />
      ) : (
        <p className="text-[#808285] font-medium text-[14px]">No video available for this listing</p>
      )}
    </div>
  );
};

export default YouTubeVideoComponent;
